import React from 'react';
import plantFloor from '@assets/LandingPage/PainPoints/L&D_Head.jpg';
import hrReview from '@assets/LandingPage/PainPoints/HR_Leader.jpg';
import lmsStorehouse from '@assets/LandingPage/PainPoints/LMS_Problem.jpg';
import fragmentation from '@assets/LandingPage/PainPoints/Fragmentation_Problem.jpg';
import './PainPoints.css';

const items = [
  {
    eyebrow: 'L&D Head, manufacturing company',
    body: '"The plant head wants the new hire on the floor immediately. But if an incident happens before training is complete the question comes back to me."',
    imageSrc: plantFloor,
    imageAlt: 'Team meeting with training progress on whiteboard',
  },
  {
    eyebrow: 'HR leader, IT services company',
    body: '"I don\'t know whether the person learned or not unless they come back and ask a doubt."',
    imageSrc: hrReview,
    imageAlt: 'HR leader discussing training outcomes',
  },
  {
    eyebrow: 'The problem with most traditional LMS tools',
    body: 'Existing LMS platforms are content storehouses. You push a course, you get a completion tick. What actually changed on the job? Nobody knows.',
    imageSrc: lmsStorehouse,
    imageAlt: 'Learner viewing generic course content on tablet',
  },
  {
    eyebrow: 'The fragmentation problem',
    body: 'Most organisations run 4-5 different LMS tools — one for sales, one for compliance, one for HR. Each adds complexity. None gives a single view.',
    imageSrc: fragmentation,
    imageAlt: 'Multiple disconnected training documents and reports',
  },
];

export default function PainPoints() {
  return (
    <section className="pain-points">
      <div className="pain-points__header">
        <div className="pain-points__eyebrow">Sound familiar?</div>
        <h2 className="pain-points__heading">
          Training is happening. But nobody knows if it&apos;s working.
        </h2>
        <p className="pain-points__sub">
          Four things we keep hearing from L&amp;D and HR leaders before they
          found a better way to track what&apos;s actually landing.
        </p>
      </div>

      {items.map((item, index) => {
        const reversed = index % 2 === 1;
        const bandClass = index % 2 === 0
          ? 'pain-points__row-band pain-points__row-band--cream'
          : 'pain-points__row-band pain-points__row-band--peach';
        return (
          <div key={index} className={bandClass}>
            <div className={`pain-points__row ${reversed ? 'pain-points__row--reversed' : ''}`}>
              <div className="pain-points__text-col">
                <p className="pain-points__eyebrow-item">{item.eyebrow}</p>
                <p className="pain-points__body">{item.body}</p>
              </div>
              <div className="pain-points__image-col">
                <div className="pain-points__image-frame">
                  <div className="pain-points__image-inner">
                    <img src={item.imageSrc} alt={item.imageAlt} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}

    </section>
  );
}
